import { useQuery } from '@tanstack/react-query';
import { EligibilityApi } from 'src/api';
import { EligibilityResponse } from 'src/api/eligibility/types';
import { FIVE_MINUTES } from 'src/constants/times.const';

export const useEligibility = (languagePairId?: number | null) => {
  const enabled = typeof languagePairId === 'number';

  const { data, isLoading } = useQuery<EligibilityResponse | null>({
    queryKey: ['eligibility', languagePairId],
    queryFn: () => EligibilityApi.getEligibility(languagePairId as number),
    enabled,
    gcTime: FIVE_MINUTES,
    staleTime: FIVE_MINUTES,
  });

  return {
    eligibility: data ?? null,
    isLoading: enabled && isLoading,
    isEligibleForPathways: !!data?.isEligibleForPathways,
    isEligibleFor2026Onboarding: !!data?.isEligibleFor2026Onboarding,
    isEligibleForTracksAndThemes: !!data?.isEligibleForTracksAndThemes,
  };
};
